var map = {
	"./LOGONew.png": "5f36",
	"./bg.png": "4bae",
	"./bg2.png": "4f38",
	"./bgNew.png": "cfcf",
	"./bszn.png": "a369",
	"./djbl.png": "e947",
	"./dw.png": "7a97",
	"./dwNew.png": "2db6",
	"./dzjg.png": "b700",
	"./gsgg.png": "959d",
	"./header.png": "23403",
	"./hz.png": "53bb",
	"./logo.png": "1231",
	"./logo3.png": "43be",
	"./logoHeader.png": "1888",
	"./title-icon.png": "b7c2",
	"./wsyy.png": "5ea2",
	"./wxUrl.png": "e05a",
	"./wxgzh-8cm.jpg": "8f91",
	"./xxcx.png": "f4e9",
	"./zcfg.png": "c1ac",
	"./zxjf.png": "a7ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38b1";